import React from 'react';

import t from '../lib/I18n';

const SkipToContentLink = () => (
    <a href="#route__content" className="skip-to-content-link padding--vert-sm padding--horiz">
        { t('skipToContent') }
    </a>
);

export default SkipToContentLink;
